/* eslint-disable max-len */
import React from 'react';
import {
  HashRouter as Router, Routes, Route, Outlet, Navigate, useNavigate,
} from 'react-router-dom';
import './App.css';
import { LoadScript } from '@react-google-maps/api';
import LoginPage from './pages/LoginPageComponent';
import OneTimePassword from './pages/OneTimePasswordComponent';
import HomePage from './pages/HomePageComponent';
import VendorManagement from './pages/VendorComponent';
import ForcePasswordReset from './pages/ForcePasswordResetComponent';
import CategoryManagement from './pages/CategoryManagementComponent';
import UserManagement from './pages/UserComponent';
import Dashboard from './components/DashboardComponent';
import UserResetPassword from './components/UserResetPassword';
import ApplicationStore from './utils/localStorageUtil';
import ManagementReportTab from './components/reportSectionComponents/ManagementReportTab';
import AppVersion from './components/AppVersion';
import EmailConfig from './pages/EmailConfig';
import MastersListTools from './components/Masters/MastersListTools';
import AttendenceList from './components/Attendence/AttendenceList';
import DeviceManagement from './components/DeviceManagement/DeviceManagement';
import StudentTab from './components/Student/StudentTab';
import StudentSms from './components/StudentSms/StudentSms';
import BdaSemDashboard from './components/StudentSubjectCardDashboard/BdaSemDashboard';
import AttendenceTab from './components/Attendence/AttendenceTab';
import StudentAddDevice from './components/StudentDevice/StudentAddDevice';
import HistoryTab from './components/StudentHistory/HistoryTab';
import StudentReportTab from './components/StudentReport/StudentReportTab';
import StdSemTransferTab from './components/StudentSemTransfer/StdSemTransferTab';
import LAttendanceTab from './components/LiveAttendance/LAttendanceTab';
import HodDashboard from './pages/Dashboardhod';
import AttendenceModificationTab from './components/StudentAttendenceModification/AttendenceModificationTab';
import StudentUserTab from './components/StudentUser/StudentUserTab';
import SMSWalletModule from './components/SmsPortal/SMSWalletModule';

function ProtectedRoutes() {
  const navigate = useNavigate();
  const { user_token, userDetails } = ApplicationStore().getStorage('userDetails');

  if (user_token) {
    if (userDetails?.secondLevelAuthorization === 'true' || userDetails?.forcePasswordReset === 1) {
      navigate('/login');
    }
    return <Outlet />;
  }

  return <Navigate replace to="/login" />;
}

function App() {
  return (
    <div className="App">
      <LoadScript googleMapsApiKey="mafsgyehbajsd-swertyuioplkjhgfdsaqwerty">
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<ProtectedRoutes />}>
              <Route path="/otp" element={<OneTimePassword />} />
              <Route path="/passwordReset" element={<ForcePasswordReset />} />
              <Route path="/" element={<HomePage />}>
                <Route path="UserManagement/*" element={<UserManagement />} />
                <Route path="Vendor/*" element={<VendorManagement />} />
                <Route path="EmailConfig" element={<EmailConfig />} />
                <Route path="Report/*" element={<ManagementReportTab />} />
                <Route path="ChangePassword/*" element={<UserResetPassword />} />
                <Route path="AppVersion/*" element={<AppVersion />} />
                <Route path="Dashboard/*" element={<Dashboard />} />
                <Route path="Dashboardhod/*" element={<HodDashboard />} />
                <Route path="Device/*" element={<CategoryManagement />} />
                <Route path="MasterList/*" element={<MastersListTools />} />
                <Route path="AttendenceList/*" element={<AttendenceList />} />
                <Route path="DeviceManagement/*" element={<DeviceManagement />} />
                <Route path="StudentTab/*" element={<StudentTab />} />
                <Route path="SMSWalletModule/*" element={<SMSWalletModule />} />
                <Route path="StudentUserList/*" element={<StudentUserTab />} />
                <Route path="StudentSms/*" element={<StudentSms />} />
                <Route path="BdaSemDashboard/*" element={<BdaSemDashboard />} />
                <Route path="AttendenceTab/*" element={<AttendenceTab />} />
                <Route path="StudentAddDevice/*" element={<StudentAddDevice />} />
                <Route path="HistoryTab/*" element={<HistoryTab />} />
                <Route path="StudentReportTab/*" element={<StudentReportTab />} />
                <Route path="StdSemTransferTab/*" element={<StdSemTransferTab />} />
                <Route path="LAttendanceTab/*" element={<LAttendanceTab />} />
                <Route path="/AttendenceModification" element={<AttendenceModificationTab />} />
              </Route>
            </Route>
          </Routes>
        </Router>
      </LoadScript>
    </div>
  );
}

export default App;
